<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-09-06 15:12:11
 * @LastEditTime: 2020-05-13 17:22:59
 * @LastEditors: 山淑兰
 -->

<template>
  <div class="my">
    <main>
      <div class="my-top">
        <img :src="userInfo.Avatar">
        <p>{{userInfo.NickName}}</p>
        <p>{{userInfo.Phone}}</p>
      </div>  
      <div class="my-bot">
        <div class="my-row" @click="joinMeeting">
          我的参会记录
          <van-icon name="arrow" size="16px" />
        </div>
        <div class="my-row" @click="bindPhone">
          修改绑定手机号
          <van-icon name="arrow" size="16px" />
        </div>
      </div>
      <div class="my-bot" v-if="myShow">
        <div class="my-row" @click="outLogin">
          退出登录
          <van-icon name="arrow" size="16px" />
        </div>
      </div>
    </main>
    <!-- <Nav v-if="fNavShow"></Nav> -->
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import { Dialog } from 'vant'
export default {
  name: 'my',
  data() {
    return {
      fNavShow: true,
      userInfo: '',
      myShow: true
    }
  },
  created() {
    //this.inits()
    this.myInfo()
    if (this.isWeiXin()) {
      this.myShow = false
    } else {
      this.myShow = true
    }
  },
  methods: {
    //判断是否为微信访问
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    joinMeeting(){
      this.$router.push({
          path: '/signup/joinMeeting',
          query: this.$route.query,
      })
    },
    bindPhone(){
      this.$router.push({
          path: '/signup/modifyPhone',
          query: this.$route.query,
      })
    },
    outLogin(){
      Dialog.confirm({
        message: '确认退出么？'
      }).then(() => {
        // on confirm
        localStorage.clear()
        //Cookies.clear()
        localStorage.removeItem('wqToken')
        Cookies.remove('wqToken')
        this.$router.push({
          path: '/login',
          query: this.$route.query,
        })
      }).catch(() => {
        // on cancel
      });
    },
    async myInfo() {
      try {
        const params = {m:this.$route.query.m};
        const res = await this.$http.userCentert(params);
        //console.error(res);
        this.userInfo = res
      } catch (error) {
        console.error(error);
      }
    },
    async inits() {
      try {
        const params = {m:this.$route.query.m};
        const res = await this.$http.initMeetingInfo(params);
        sessionStorage.setItem("HomeUrl",res.HomeUrl)
        sessionStorage.setItem("isshowlogo",res.isshowlogo)
      } catch (error) {
        console.error(error);
      }
    }
  }

};
</script>
<style lang="scss">
.my {
  padding-bottom: 85px;
  .my-top{
    background: #3c51e4;
    text-align: center;
    padding: 100px 0;
    img{
      width: 140px;
      height: 140px;
      border-radius: 50%;
      border: 1px solid #fff;
    }
    p{
      font-size: 30px;
      color: #fff;
      margin-top: 30px;
    }
  }
  .my-bot{
    padding: 0 30px;
    background: #fff;
    margin-bottom: 20px;
    
    .my-row{
      font-size: 26px;
      color: #666;
      height: 100px;
      line-height: 100px;
      border-bottom: 1px solid #ddd;
      .van-icon{
        float: right;
        vertical-align: middle;
        display: block;
        height: 100px;
        line-height: 100px;
      }
    }
    .my-row:last-child{
      border-bottom: none;
    }
  }
}

</style>


